module.exports = __webpack_public_path__ + "static/img/1098.9270517.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1098.jpg
// module id = 280
// module chunks = 0